<template >
    <div style="">
        <div style="width:100%;" >

            <div style="top:-156px;position:fixed;width:100%;">
            <div style="z-index:0;position:relative;width:100%;height:calc(100vh + 200px);margin-left:0;background: rgb(154,255,186);background: linear-gradient(40deg, rgba(164, 65, 248, 0.72) 0%, rgb(47, 218, 158) 100%);">
                <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="pointer-events: none;z-index: -1;">
                    <source :src="require('../assets/white_flare.webm')" type="video/webm">

                </video>
                <video  loop="" muted="" autoplay=""  style="opacity: 0.2;pointer-events: none;z-index: -1;width:100%;">">
                    <source :src="require('../assets/flowyo_2.mp4')">
                </video>


            </div>




            </div>
            <v-row
                    align="center"
                    justify="center"

                    class="mx-auto"
                    style="height:80vh;top:0;z-index: 0;position: fixed;width:100%;"

            >


                <v-col align="center"  style="max-width:600px;background: rgba(129, 134, 169, 0.34); border-radius: 20px;padding:20px;" >
                    <h1 class="display-3 font-weight-bold mb-3 text--uppercase" >Doneramera!</h1>

                    <h3 class="font-weight-light" style="margin-top:40px;">Du skapar snabbt och enkelt din egen Hihat-sida och kan därefter omedelbart ta emot notiser betalda med Swish.</h3>

                    <span>
                    <v-btn v-if="!$store.getters.loggedIn" block class="mx-auto my-12" x-large @click="letsgo" dark style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" color="teal">Kom igång </v-btn>
                    <v-btn v-else-if="$store.getters.loggedIn" block class="mx-auto my-12" x-large @click="letsgome" dark style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" color="teal">Min sida</v-btn>

                </span>


                </v-col>

            </v-row>
            <v-row v-show="$vuetify.breakpoint.lgAndUp">
                <v-col>
                    <DonationLeaderboard style="z-index: 100;position:absolute;top:265px;left:40px;" :isDark=false :local=false></DonationLeaderboard>

                </v-col>
                <v-col>

                </v-col>
                <v-col>

                </v-col>
            </v-row>












            <v-row align="center" justify="center" :class="$vuetify.breakpoint.mdAndUp? 'px-12':''" style="background:#e7e7e7;position: relative;margin-top: 100px;z-index: 1;padding-bottom:80px;">
                <v-col :style="{'margin-left':$vuetify.breakpoint.mdAndDown?'0px !important':$vuetify.breakpoint.lgAndDown?'250px !important':'0px !important'}" justify="center" style="max-width:800px;">
                    <div style="color:gray;text-align:center;font-size: 1.25rem; font-weight: 500; letter-spacing: 0.0125em; line-height: 2rem;padding:16px;">Road to <span style="text-decoration: line-through;">Global</span> Hihat*</div>
                    <v-timeline :dense="$vuetify.breakpoint.mdAndDown" >
                        <v-timeline-item
                                color="#6b559c"
                                large
                                icon="mdi-numeric-1-circle-outline"


                        >

                            <template v-slot:opposite>
                                <span style="color:black"></span>
                            </template>
                            <v-card style="background: linear-gradient(279deg, rgba(94,80,141,1) 0%, rgba(107,85,156,1) 100%);" dark class="elevation-2" >
                                <v-card-title >Skapa Hihat-konto</v-card-title>
                                <v-card-text style="padding-top:0;padding-bottom:16px;margin-top:-12px;">
                                    Att skapa ett Hihat-konto är helt gratis, och tar en sisådär 30 sekunder
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>
                        <v-timeline-item
                                color="#647995"
                                large
                                icon="mdi-numeric-2-circle-outline"
                        >

                            <template v-slot:opposite>
                                <span style="color:black"></span>
                            </template>
                            <v-card dark style="background: linear-gradient(279deg, rgba(100,121,149,1) 0%, rgba(80,128,141,1) 100%);" class="elevation-2">
                                <v-card-title >Ange betaluppgifter</v-card-title>
                                <v-card-text style="padding-top:0;padding-bottom:16px;margin-top:-12px;" >
                                    Skriv in det bankkonto du vill ha donationer utbetalt till eller ange ett telefonnummer
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>
                        <v-timeline-item
                                color="#508d7d"
                                large
                                icon="mdi-numeric-3-circle-outline"
                        >

                            <template v-slot:opposite>
                                <span style="color:black"></span>
                            </template>
                            <v-card dark style="background: linear-gradient(279deg, rgba(54,185,150,1) 0%, rgba(80,141,125,1) 100%);" class="elevation-2">
                                <v-card-title>Koppla alerts</v-card-title>
                                <v-card-text style="padding-top:0;padding-bottom:16px;margin-top:-12px;">
                                    Lägg till Hihats browser-source, eller anslut till <b>Streamlabs</b>/<b>Streamelements</b>-konto
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>
                        <v-timeline-item
                                color="#57d79f"
                                large
                                icon="mdi-numeric-4-circle-outline"
                        >

                            <template v-slot:opposite>
                                <span style="color:black"></span>
                            </template>
                            <v-card dark class="elevation-2" style="background: linear-gradient(279deg, rgba(87,215,159,1) 0%, rgba(54,185,150,1) 100%);">
                                <v-card-title>Grattis!</v-card-title>
                                <v-card-text style="padding-top:0;padding-bottom:16px;margin-top:-12px;">
                                    Dina tittare kan nu donera till dig genom din Hihat-sida
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>

                    </v-timeline>
                </v-col>
            </v-row>
            <svg   style="position:relative;z-index: 1;margin-bottom:0;pointer-events: none;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#e7e7e7" fill-opacity="1" d="M0,64L24,64C48,64,96,64,144,64C192,64,240,64,288,74.7C336,85,384,107,432,101.3C480,96,528,64,576,85.3C624,107,672,181,720,181.3C768,181,816,107,864,117.3C912,128,960,224,1008,266.7C1056,309,1104,299,1152,245.3C1200,192,1248,96,1296,85.3C1344,75,1392,149,1416,186.7L1440,224L1440,0L1416,0C1392,0,1344,0,1296,0C1248,0,1200,0,1152,0C1104,0,1056,0,1008,0C960,0,912,0,864,0C816,0,768,0,720,0C672,0,624,0,576,0C528,0,480,0,432,0C384,0,336,0,288,0C240,0,192,0,144,0C96,0,48,0,24,0L0,0Z"></path>

            </svg>

            <svg   style="position:relative;z-index: 1;margin-bottom:-10px;pointer-events: none;margin-top:300px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#e7e7e7" fill-opacity="1" d="M0,64L24,64C48,64,96,64,144,64C192,64,240,64,288,74.7C336,85,384,107,432,101.3C480,96,528,64,576,85.3C624,107,672,181,720,181.3C768,181,816,107,864,117.3C912,128,960,224,1008,266.7C1056,309,1104,299,1152,245.3C1200,192,1248,96,1296,85.3C1344,75,1392,149,1416,186.7L1440,224L1440,320L1416,320C1392,320,1344,320,1296,320C1248,320,1200,320,1152,320C1104,320,1056,320,1008,320C960,320,912,320,864,320C816,320,768,320,720,320C672,320,624,320,576,320C528,320,480,320,432,320C384,320,336,320,288,320C240,320,192,320,144,320C96,320,48,320,24,320L0,320Z"></path>

            </svg>

            <div style="background:#e7e7e7;position: relative;z-index: 1;">
                <v-row style="min-height:80px;">
                    <v-col>
                        <v-img v-show="guthen_show" :class="guthen_spinning?'spin_da_guthen':''" @click="guthenSpin" height="28" width="28"  style="z-index: 40;left:100px;cursor:pointer;overflow:visible;" :src="require('../assets/guthenPog.png')"><span style="margin-left:25px;text-shadow: 4px 4px 20px black;">{{guthentext}}</span></v-img>

                    </v-col>
                </v-row>
            <v-row justify="center" class="mx-auto" style="padding-bottom:80px;margin-top:-100px;">


                <v-col :cols="$vuetify.breakpoint.mdAndUp? '6' : '12'">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <div style="color:gray;text-align:center;font-size: 1.25rem; font-weight: 500; letter-spacing: 0.0125em; line-height: 2rem;padding:16px;">Hihat-<b>classic</b></div>
                        <v-card-text style="text-align: center;">
                            Hihat-classic passar dig som satsar på streaming. Vi betalar ut dina donationer i en klumpsumma varje månad, som en lön. Det innebär att vi betalar in och redovisar all skatt enligt tabell 31 till Skatteverket, så att du slipper. Med Hihat-classic hålls din identitet hemlig och dina tittare får inte tillgång till någon av din information. Med Hihat-classic kan vi även garantera att dina alerts fungerar till 100%.

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-chip style="position: relative;">+Anonymt</v-chip>
                            <v-chip style="position: relative;">+Skattat</v-chip>
                            <v-chip style="position: relative;">+Alert-garanti</v-chip>

                            <v-spacer></v-spacer>


                        </v-card-actions>

                    </v-card>
                </v-col>

                <v-col :cols="$vuetify.breakpoint.mdAndUp? '6' : '12'">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <div style="color:gray;text-align:center;font-size: 1.25rem; font-weight: 500; letter-spacing: 0.0125em; line-height: 2rem;padding:16px;">Hihat-<b>direkt</b></div>
                        <v-card-text style="text-align: center;">
                            Hihat-direkt passar dig som är mer <i>casual</i> i ditt streamande och inte förväntar dig donationer på över 100 kr i månaden. Med Hihat-direkt går alla donationer direkt till dig, och du blir ansvarig för att rapportera och betala in skatt till Skatteverket.
                        </v-card-text>

                    </v-card>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-chip style="position: relative;">+Direkt</v-chip>
                        <v-spacer></v-spacer>


                    </v-card-actions>
                </v-col>
                <v-col cols="12">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">

                        <v-card-text style="text-align: center;">
                           Alla Hihat-konton är gratis att skapa och transaktionsavgifter för Hihat-<b>classic</b> och Hihat-<b>direkt</b> är samma. Läs mer om Hihats <a>avgifter</a>
                        </v-card-text>

                    </v-card>
                </v-col>
                <v-col align="center" cols="12" >
                    <v-simple-table dark style="max-width:800px;background: linear-gradient(40deg, rgba(96,55,170,0.72) 0%, rgb(41,160,118) 100%);">
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th style="color:white !important;" class="text-left"></th>
                                <th style="color:white !important;" class="text-left">Swish</th>
                                <th style="color:white !important;" class="text-left">Skattat</th>
                                <th style="color:white !important;" class="text-left">Anonymt</th>
                                <th style="color:white !important;" class="text-left">Alert-garanti</th>
                                <th style="color:white !important;" class="text-left">Utbetalningstyp</th>
                                <th style="color:white !important;" class="text-left">Start-avgift</th>
                                <th style="color:white !important;" class="text-left">Transaktions-avgift</th>





                            </tr>
                            </thead>
                            <tbody>
                            <tr >
                                <td>Hihat <b>classic</b></td>
                                <td><v-icon>mdi-check</v-icon></td>
                                <td><v-icon>mdi-check</v-icon></td>
                                <td><v-icon>mdi-check</v-icon></td>
                                <td><v-icon>mdi-check</v-icon></td>
                                <td>Månadsvis</td>
                                <td>0 kr</td>
                                <td>3.25 SEK + 3.25 %</td>
                            </tr>
                            <tr >
                                <td>Hihat <b>direkt</b></td>
                                <td><v-icon>mdi-check</v-icon></td>
                                <td><v-icon>mdi-close</v-icon></td>
                                <td><v-icon>mdi-close</v-icon></td>
                                <td><v-icon>mdi-close</v-icon></td>
                                <td>Direkt</td>
                                <td>0 kr</td>
                                <td>3.25 SEK + 3.25 %</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>


            </v-row>
            </div>


            <div style="background:#e7e7e7;position: relative;z-index: 1;margin-top:400px;">
                <v-row align="center" justify="center" class="mx-auto" style="padding-bottom:80px;">


                    <v-col :cols="$vuetify.breakpoint.mdAndUp? '6' : '12'">
                        <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                            <div style="color:gray;text-align:center;font-size: 1rem; font-weight: 500; letter-spacing: 0.0125em; line-height: 2rem;padding:16px;">Hihat Browser Source</div>
                            <v-card-text style="text-align: center;">
                                <v-img height="256" width="256" class="mx-auto" :src="require('../assets/hihat_example_alert2.gif')">

                                </v-img>

                                Med Hihats egna browser source kommer du igång med din streaming på nolltid.

                            </v-card-text>


                        </v-card>
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.mdAndUp? '6' : '12'">
                        <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                            <div style="color:gray;text-align:center;font-size: 1rem; font-weight: 500; letter-spacing: 0.0125em; line-height: 2rem;padding:16px;">Streamlabs & Streamelements</div>
                            <v-row align="center" justify="center" style="min-height: 256px;">
                                <v-col cols="3"></v-col>
                                <v-col cols="3" style="text-align: right">
                                    <v-img height="128" width="128" contain class="mx-auto" :src="require('../assets/streamlabs_icon.png')">
                                    </v-img>
                                </v-col>
                                <v-col cols="3">
                                    <v-img height="128" width="128" class="mx-auto" contain :src="require('../assets/streamelements_icon.png')">
                                    </v-img>
                                </v-col>
                                <v-col cols="3"></v-col>

                            </v-row>



                            <v-card-text style="text-align: center;">
                                Om du redan streamat med Streamlabs eller Streamelements är det dunderenkelt att ansluta ett Hihat-konto. Då visas dina Hihat-alerts på samma sätt som tidigare.

                            </v-card-text>

                        </v-card>
                    </v-col>




                </v-row>
            </div>
            <svg   style="position:relative;z-index: 1;margin-bottom:-10px;pointer-events: none;margin-top:0px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#e7e7e7" fill-opacity="1" d="M0,192L26.7,208C53.3,224,107,256,160,229.3C213.3,203,267,117,320,80C373.3,43,427,53,480,74.7C533.3,96,587,128,640,160C693.3,192,747,224,800,213.3C853.3,203,907,149,960,112C1013.3,75,1067,53,1120,48C1173.3,43,1227,53,1280,58.7C1333.3,64,1387,64,1413,64L1440,64L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z"></path>

            </svg>


















        </div>


    </div>
</template>

<script>
    import DonationLeaderboard from "../components/DonationLeaderboard";
    export default {
        name: 'Donations',
        components: {
            DonationLeaderboard

        },
        data(){
            return{
                guthen_spinning:false,
                guthentext:"",
                guthen_show:true
            }

        },
        computed:{

            minHeight () {
                const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

                return `calc(${height} - ${this.$vuetify.application.top}px)`
            }
        },
        methods:{
            letsgo:function(){
                this.$store.state.APP.SHOW_LOGIN=true;
            },
            letsgome:function(){
                this.$router.push({ path: `/${this.$store.state.STYLE.PATH}` })

            },
            guthenSpin:function(){
                this.guthen_spinning=true;
                let self=this;
                setTimeout(function(){
                    self.guthen_spinning=false;
                    self.guthentext="";
                    self.guthen_show=false
                },3000);
                this.guthentext="P";
                for(let i=0;i<3;i++){
                    setTimeout(function(){
                        self.guthentext+="o"
                    },i*200)
                }
                setTimeout(function(){
                    self.guthentext+="g"

                },800)
            }

        },
        mounted:function(){
            document.title="Hihat";


        }

    }
</script>

<style scoped>
    .lift_me_up> * img{
        top:-200px;
    }

    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .spin_da_guthen{
        animation-name: spin;
        animation-duration: 1000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        /* transform: rotate(3deg); */
        /* transform: rotate(0.3rad);/ */
        /* transform: rotate(3grad); */
        /* transform: rotate(.03turn);  */
    }

    .theme--dark.v-data-table tbody tr:hover{
        background: rgba(255,255,255,0.1) !important;
    }
</style>
